import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const BriefIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M20 2.5a1 1 0 0 1 1 1v3.757h-2V4.5H5v16h14v-2.758h2V21.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-18a1 1 0 0 1 1-1h16Zm-7 10v2H8v-2h5Zm3-4v2H8v-2h8Z"/>
        <path d="M16.142 12.325c2.22-.432 3.223-1.444 3.652-3.682.037-.19.307-.19.345 0 .428 2.238 1.431 3.25 3.65 3.682.19.037.19.31 0 .348-2.219.431-3.222 1.446-3.65 3.684-.038.19-.308.19-.345 0-.429-2.238-1.432-3.25-3.652-3.684-.19-.038-.19-.31 0-.348Z"/>
    </svg>
);
BriefIcon.displayName = 'BriefIcon';
export default BriefIcon;
